import _ from 'underscore';

import { allEnumValues, VitrineCoverBlockType } from '@biteinc/enums';
import { StringHelper } from '@biteinc/helpers';
import { menuCoverSchema } from '@biteinc/schemas';

const { fields: DisplayBlockFields } = menuCoverSchema.fields.portraitBlocks;

app.MenuCoverDisplayBlockView = app.AccordionFieldView.extend({
  initialize(options) {
    _.extend(options || {}, {
      newElementDropdown: {
        getCollection: () => {
          return app.AbstractCollection.createFromTsEnum({
            tsEnum: VitrineCoverBlockType,
            nameGenerator: (name) => {
              return name.split('_').map(StringHelper.toTitleCase).join(' ');
            },
            // Temp: hide video blocks from non-bite users
            ...(!app.sessionUser.isBite() && {
              values: allEnumValues(VitrineCoverBlockType).filter((blockType) => {
                switch (blockType) {
                  case VitrineCoverBlockType.CoverVideoExtraSmall:
                  case VitrineCoverBlockType.CoverVideoLarge:
                  case VitrineCoverBlockType.CoverVideoMedium:
                  case VitrineCoverBlockType.CoverVideoSmall:
                    return false;
                  default:
                    return true;
                }
              }),
            }),
          });
        },
        getNewElementFromModel: (blockTypeModel) => {
          const blockType = blockTypeModel.id;
          return {
            type: blockType,
          };
        },
        canShowModel: (blockTypeModel, elements) => {
          // Filter out the block types that are already entered (but maybe not saved)
          return !_.findWhere(elements, { blockType: blockTypeModel.id });
        },
      },
      getTitle: (fieldGroupView) => {
        const { type } = fieldGroupView.getValue();

        if (!type) {
          return '';
        }

        let titleAppendix = '';
        if (type === VitrineCoverBlockType.Pathway) {
          titleAppendix = ` - ${fieldGroupView
            .getValue()
            .pathways?.map((pathway) => StringHelper.toTitleCase(pathway.linkType))
            .join(', ')}`;
        }

        return (
          type
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ') + titleAppendix
        );
      },
      getElementSchemaFields: (/* element */) => {
        return DisplayBlockFields;
      },
      templateData: {
        title: options.schema.displayName || options.field,
        buttonText: 'new cover block',
        emptyText: 'no cover blocks yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },

  _fieldGroupViewDidChangeValue() {
    // Preserve the base behavior (re-emits FieldDidChangeValue up the tree).
    app.AccordionFieldView.prototype._fieldGroupViewDidChangeValue.apply(this, arguments);
    this._mirrorLargeImageToFallback();
  },

  // When a Cover Image Large block has an image, mirror it into the cover's fallbackCoverImg so a cover
  // that shows a full-screen image is its own fallback. Runs on any block change (idempotent when
  // unchanged) and never clears the fallback, so removing the block leaves the existing fallback as-is.
  _mirrorLargeImageToFallback() {
    const largeImageBlock = _.find(
      this.getValue() || [],
      (block) =>
        block.type === VitrineCoverBlockType.CoverImageLarge && block.imagePortraitLg?.length,
    );
    if (!largeImageBlock) {
      return;
    }

    const fallbackFieldView = this.fieldGroupView?.fieldViewsByField?.fallbackCoverImg;
    if (!fallbackFieldView) {
      return;
    }

    fallbackFieldView.setValue(largeImageBlock.imagePortraitLg, this.model);
  },
});
